import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.75 0h-18A.75.75 0 0 0 0 .75V13.5A1.5 1.5 0 0 0 1.5 15H18a1.5 1.5 0 0 0 1.5-1.5V.75a.75.75 0 0 0-.75-.75m-1.931 1.5L9.75 7.978 2.681 1.5zM1.5 2.456V13.5H18V2.456l-7.744 7.097a.75.75 0 0 1-1.012 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }